<ngx-loading-bar
  [color]="isSandboxEnvironment ? '#111111' : '#046A4E'"
  [includeSpinner]="false"
  [includeBar]="true"
></ngx-loading-bar>
<router-outlet></router-outlet>
